import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import Brand from './component/Brand';
import BuyAccesory from './component/BuyAccesory';
import BuyContent from './component/BuyContent';
import BuyList from './component/BuyList';
import BuyTocTocBox from './component/BuyTocTocBox';
import ChnLang from './component/ChnLang';
import Contents from './component/Contents';
import English from './component/English';
import Entertainment from './component/Entertainment';
import Eraser from './component/Eraser';
import Faq from './component/Faq';
import Footer from './component/Footer';
import KidsHomeT from './component/KidsHomeT';
import KorLang from './component/KorLang';
import MainContent from './component/MainContent';
import Math from './component/Math';
import Navi from './component/Navi';
import Notice from "./component/Notice";
import NoticeDetail from "./component/NoticeDetail";
import PlayEducation from './component/PlayEducation';
import Profile from './component/Profile';
import Programs from './component/Programs';
import ReadBook from './component/ReadBook';
import SsukssukPen from './component/SsukssukPen';
import TokTokLearn from './component/TokTokLearn';
import TokTokLive from './component/TokTokLive';
import TokTokPen from './component/TokTokPen';
import TokTokPlay from './component/TokTokPlay';

import { createContext, useContext, useState } from "react";


export const MyContext = createContext();

// 컨텍스트 제공자 컴포넌트
function MyProvider({ children }) {
  const [choiceValue, setValue] = useState({userId:-1, amount: 0, productColor:"", productAmount:1});

  return (
    <MyContext.Provider value={{ choiceValue, setValue }}>
      {children}
    </MyContext.Provider>
  );
}

function MyComponent() {
  const { value, setValue } = useContext(MyContext);

  const handleChange = (event) => {
    setValue(event.target.value);
  }

  return (
    <div>
      <input type="text" value={value} onChange={handleChange} />
    </div>
  );
}

function App() {
  return (
    <MyProvider>
      <div className="App">
        <BrowserRouter>
          <Navi></Navi>
          <Routes>
            <Route path="/" element={<MainContent></MainContent>}></Route>
            <Route path="/brand" element={<Brand></Brand>}></Route>
            {/* <Route path="/productannounce" element={<ProductAnnounce></ProductAnnounce>}></Route> */}
            <Route path="/toktokpen" element={<TokTokPen></TokTokPen>}></Route>
            <Route path="/ssukssukpen" element={<SsukssukPen></SsukssukPen>}></Route>
            <Route path="/eraser" element={<Eraser></Eraser>}></Route>
            <Route path="/toktoklearn" element={<TokTokLearn></TokTokLearn>}></Route>
            <Route path="/toktoklive" element={<TokTokLive></TokTokLive>}></Route>
            <Route path="/toktokplay" element={<TokTokPlay></TokTokPlay>}></Route>

            <Route path="/english" element={<English></English>}></Route>
            <Route path="/readbook" element={<ReadBook></ReadBook>}></Route>
            <Route path="/playeducation" element={<PlayEducation></PlayEducation>}></Route>
            <Route path="/math" element={<Math></Math>}></Route>
            <Route path="/kidshomet" element={<KidsHomeT></KidsHomeT>}></Route>
            <Route path="/korlang" element={<KorLang></KorLang>}></Route>
            <Route path="/chnlang" element={<ChnLang></ChnLang>}></Route>
            <Route path="/contents" element={<Contents></Contents>}></Route>
            <Route path="/programs" element={<Programs></Programs>}></Route>
            <Route path="/entertainment" element={<Entertainment></Entertainment>}></Route>
            <Route path="/profile" element={<Profile></Profile>}></Route>
            <Route path="/community/notice/:page" element={<Notice></Notice>}></Route>
            <Route path="/community/notice/:page/:listType" element={<Notice></Notice>}></Route>
            <Route path="/community/notice-detail/:page/:idx/:listType" element={<NoticeDetail></NoticeDetail>}></Route>
            <Route path="/buytoctocbox" element={<BuyTocTocBox></BuyTocTocBox>}></Route>
            <Route path="/BuyAccesory" element={<BuyAccesory></BuyAccesory>}></Route>
            <Route path="/BuyContent" element={<BuyContent></BuyContent>}></Route>
            <Route path="/buylist" element={<BuyList></BuyList>}></Route>
            <Route path="/Faq" element={<Faq></Faq>}></Route>
          </Routes>

          <Footer></Footer>
        </BrowserRouter>
      </div>
    </MyProvider>
  );
}

export default App;
